import { useCallback, useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';

export const DEFAULT_CHART_HEIGHT = 280;

/**
 * Measures the chart column width for Recharts SVG sizing (100% of parent, not a fixed cap).
 */
export function useChartContainerWidth(
  layoutWidthOverride?: number,
  chartHeight = DEFAULT_CHART_HEIGHT,
) {
  const [measuredWidth, setMeasuredWidth] = useState(0);

  const onLayout = useCallback((event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout;
    if (width > 0) {
      setMeasuredWidth(width);
    }
  }, []);

  const chartWidth = layoutWidthOverride ?? measuredWidth;

  return {
    chartWidth,
    onLayout,
    chartHeight,
  };
}
